import Schedule from '@/api/schedule'
import AcademicYear from '@/api/academic-year'
import ProgramMain from '@/api/main-program'
import ProgramSub from '@/api/sub-program'
import AcademicClass from '@/api/class-operation'
import room from '@/api/room'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  found_data: {},
  academicYears: [],
  programMains: [],
  programSubs: [],
  classes: [],
  weekDays: [],
  scheduleTypes: [],
  academicSubjects: [],
  rooms: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FOUND_DATA(state, data) {
    state.found_data = data
  },
  RECEIVE_ACADEMIC_YEARS(state, data) {
    state.academicYears = data
  },
  RECEIVE_ACADEMIC_PROGRAM_MAINS(state, data) {
    state.programMains = data
  },
  RECEIVE_ACADEMIC_PROGRAM_SUBS(state, data) {
    state.programSubs = data
  },
  RECEIVE_CLASSES(state, data) {
    state.classes = data
  },
  SET_WEEKDAYS(state, data) {
    state.weekDays = data
  },
  SET_SCHEDULE_TYPES(state, data) {
    state.scheduleTypes = data
  },
  RECEIVE_SUBJECTS(state, data) {
    state.academicSubjects = data
  },
  SET_ROOMS(state, data) {
    state.rooms = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return Schedule.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return Schedule.store(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.found_data)) {
      let response = await Schedule.find(id)
      context.commit('SET_FOUND_DATA', response.data)
    }
  },
  updateClass(context, { sch_id, ...data }) {
    return Schedule.updateClass(sch_id, data.data)
  },
  destroy(context, id) {
    return Schedule.destroy(id)
  },
  previewSchedule(context, { sch_id, dept_moeys, display_language }) {
    return Schedule.previewSchedulePdf({
      sch_id: sch_id,
      dept_moeys: dept_moeys,
      display_language: display_language
    })
  },
  listTime(context, data) {
    return Schedule.getTimeList({
      params: { acps_id: data.acps_id, sch_type: data.sch_type }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchAcademicYear(context, attributes = {}) {
    return AcademicYear.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_years: 'ac_year_id,ac_year,ac_status_id'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_YEARS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchProgramMain(context, attributes = {}) {
    return ProgramMain.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_mains: 'acp_id,acp_name_native,acp_name_foreign'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_PROGRAM_MAINS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchProgramSub(context, attributes = {}) {
    return ProgramSub.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_subs: 'acps_id,acps_name_native,acps_name_foreign'
        },
        filter: {
          acp_id: attributes.acp_id
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_ACADEMIC_PROGRAM_SUBS', response.data)
      return Promise.resolve(response)
    })
  },

  async fetchSubjectTeacher(context, attributes = {}) {
    if (!context.state.rooms.length > 0) {
      let response = await room.get()
      context.commit('SET_ROOMS', response.data)
    }
    return Schedule.getSubjects({
      params: {
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_SUBJECTS', response)
      return Promise.resolve(response)
    })
  },

  fetchClass(context, attributes = {}) {
    return AcademicClass.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_classes: 'class_id,class_name,ac_status_id'
        },
        filter: {
          acps_id: attributes.acps_id,
          ac_status_id: [1, 3]
        },
        include: 'academic_status',
        ...attributes
      }
    }).then(response => {
      context.commit('RECEIVE_CLASSES', response.data)
      return Promise.resolve(response)
    })
  },
  fetchScheduleTimes(context, attributes = {}) {
    return Schedule.getScheduleTime({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        ...attributes
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.weekDays.length > 0) {
      let response = await Schedule.getWeekdays()
      context.commit('SET_WEEKDAYS', response.data)
    }
    if (!context.state.scheduleTypes.length > 0) {
      let response = await Schedule.getScheduleTypes()
      context.commit('SET_SCHEDULE_TYPES', response.data)
    }
  },
  getAcademicYear(context, attributes = {}) {
    return Schedule.academicYear({ params: attributes })
  }
}
